import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RestrictDirective} from './restrict.directive';
import {TransformInputDirective} from './transform-input.directive';
import {CustomPatternValidatorDirective} from './validators/custom-pattern-validator.directive';
import {FormatCurrencyDirective} from './format-currency.directive';
import {DragDropFileUploadDirective} from './drag-drop-file-upload.directive';

@NgModule({
    declarations: [
        RestrictDirective,
        TransformInputDirective,
        CustomPatternValidatorDirective,
        FormatCurrencyDirective,
        DragDropFileUploadDirective
    ],
    imports: [
        CommonModule
    ],
    exports: [
        RestrictDirective,
        TransformInputDirective,
        CustomPatternValidatorDirective,
        FormatCurrencyDirective,
        DragDropFileUploadDirective
    ]
})
export class DirectivesModule {
}
